module.exports = __webpack_public_path__ + "media/images/black-owned-f7778bea08b6f32c82559d28fc36bcc7.png";